import React from 'react'
import RecordForm from '../../../../../../generic/universal-table/components/RecordForm/RecordForm'
import { IWarehouseLocation } from '../../../../../../modules/API/Warehouse/models/locations'

type LocationFormProps = React.ComponentProps<typeof RecordForm<IWarehouseLocation>>

// Thin module-named wrapper so AppModal has a stable `Children` seam.
// All logic lives in the unified RecordForm.
const LocationForm = (props: LocationFormProps) => <RecordForm<IWarehouseLocation> {...props} />

export default LocationForm
